module.exports = __webpack_public_path__ + "static/AcuminVariableConcept-f96253aa198755e2134bba52090204f3.otf";